import React, {Component} from 'react'
import { connect } from 'react-redux'
import ReferralOptOutDetails from './components/Referral/ReferralOptOutDetails'
import { fetchReferral } from 'manager/redux/referral'
import {setTitle, setWhiteBanner} from 'common/redux/root'


import {
  LOAN_OPT_OUT_REASONS, SETTLEMENT_OPT_OUT_REASONS
} from 'common/constants'

const mapDispatchToProps = dispatch => ({
  dispatch
})

class ReferralOptOutDetailsContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      lender: this.props.location.pathname.includes("loan")
    }
  }

  componentWillMount() {
    const { dispatch } = this.props
    const { lender } = this.state
    dispatch(setWhiteBanner(true))
    dispatch(fetchReferral(this.props.params.hash, true)).then(
      response => {
        dispatch(setTitle("Other " + (lender ? "Mortgage Company" : "Settlement Company"), response.referral.name))
      }
    )
  }

  render() {
    const { lender } = this.state
    const { referral } = this.props

    return (
      this.props.referral ?
        <ReferralOptOutDetails
          type={lender ? "loan": "settlement"}
          networkLabel={lender ? "Lender" : "Settlement Company"}
          companyLabel={lender ? "Mortgage Company" : "Settlement Company"}
          officerLabel={lender ? "Loan" : "Settlement"}
          assignedCompany={lender ? (referral.loan_broker_profile_name || referral.loan_broker_company) : (referral.settlement_broker_profile_name || referral.settlement_broker_company)}
          assignedOfficer={lender ? referral.loan_officer_name : referral.settlement_officer_name}
          company={lender ? referral.loan_opt_out_company: referral.settlement_opt_out_company}
          officer={lender ? referral.loan_opt_out_officer : referral.settlement_opt_out_officer}
          refer={lender ? referral.loan_opt_out_refer : referral.settlement_opt_out_refer}
          email={lender ? referral.loan_opt_out_email :referral.settlement_opt_out_email}
          phone={lender ? referral.loan_opt_out_phone : referral.settlement_opt_out_phone }
          reasons={lender ? referral.loan_opt_out_reasons : referral.settlement_opt_out_reasons}
          feedback={lender ? referral.loan_opt_out_feedback : referral.settlement_opt_out_feedback}
          optOutReasons={lender ? LOAN_OPT_OUT_REASONS : SETTLEMENT_OPT_OUT_REASONS}
          hasActiveAssignment={lender ? this.props.referral.has_active_loan_assignment : referral.has_active_settlement_assignment}
          buttonText={lender ? "Submit Lender Details" : "Submit Settlement Details"}
          {...this.props}
        />
        : null)
  }
}

export default connect((state) => ({ ...state.referral, referralOptOut: state.referralOptOut }), mapDispatchToProps)(ReferralOptOutDetailsContainer)
